export function stripHexAlphaChannel(hex: string): string {
  const normalizedHex = (hex || '').trim().replace(/^#/, '')

  // Color picker in hexa mode returns RRGGBBAA; tenant API expects RRGGBB.
  if (normalizedHex.length >= 8) {
    return normalizedHex.substring(0, 6)
  }

  return normalizedHex
}
